// extracted by mini-css-extract-plugin
module.exports = {"logoItem":"biggest-names-in-solar_logoItem__SpD5O"};